module.exports = __webpack_public_path__ + "static/media/surprise 1.f92507b2.svg";